import { render, staticRenderFns } from "./tudizhan.vue?vue&type=template&id=ed5baa7c&scoped=true&"
import script from "./tudizhan.vue?vue&type=script&lang=js&"
export * from "./tudizhan.vue?vue&type=script&lang=js&"
import style0 from "./tudizhan.vue?vue&type=style&index=0&id=ed5baa7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed5baa7c",
  null
  
)

export default component.exports